
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_SETTINGS, AuthService, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { UserProfileService } from '../user-profile.service';
import { NgIf, NgClass, NgStyle } from '@angular/common';
import { IMaskDirective } from 'angular-imask';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-manage-user-info',
    templateUrl: './manage-user-info.component.html',
    styleUrls: ['./manage-user-info.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        NgStyle,
        IMaskDirective,
        RouterLink,
    ],
})
export class ManageUserInfoComponent implements OnInit, OnDestroy {

  public firstName = new UntypedFormControl('');
  public lastName = new UntypedFormControl('');
  public companyName = new UntypedFormControl('');
  public address1 = new UntypedFormControl('');
  public address2 = new UntypedFormControl('');
  public city = new UntypedFormControl('');
  public state = new UntypedFormControl('');
  public zipCode = new UntypedFormControl('');
  public phone = new UntypedFormControl('');
  public email = new UntypedFormControl('');
  public user: any;
  private subscription: ISubscription[];
  toggleEditStyles = {};
  APP_SETTINGS:any;
  screenWidth: number;

  public userForm = new UntypedFormGroup({});
  public phoneMask= {mask: '(000) 000-0000'};

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
    let username = '';
    // this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
    //   userName = userData['email'];
    // });
    username = this.authService.getUserName();
    this.subscription.push(this.userProfileService.getUsersInfoByEmail(username).subscribe(data => {
      this.user = data;
      this.firstName = new UntypedFormControl(this.user.firstName);
      this.lastName = new UntypedFormControl(this.user.lastName);
      this.companyName = new UntypedFormControl(this.user.companyName);
      this.address1 = new UntypedFormControl(this.user.address1);
      this.address2 = new UntypedFormControl(this.user.address2);
      this.city = new UntypedFormControl(this.user.city);
      this.state = new UntypedFormControl(this.user.state);
      this.phone = new UntypedFormControl(this.user.phone);
      this.zipCode = new UntypedFormControl(this.user.zipCode);
      this.email = new UntypedFormControl(this.user.email);
      this.userForm = this.fb.group({
        firstName: this.firstName,
        lastName: this.lastName,
        companyName: this.companyName,
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        phone: this.phone,
        zipCode: this.zipCode,
        email: this.email
      });
    }));
  }
  onSubmit() {
    this.user = {...this.user, ...this.userForm.value};
    this.subscription.push(this.userProfileService.updateUserInfo(this.userForm.value).subscribe());
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

}
